export const STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "in_progress", label: "In Progress" },
  { value: "paid", label: "Paid" },
];

const STYLES = {
  pending: "text-amber-400 bg-amber-400/10 border-amber-400/20",
  in_progress: "text-blue-400 bg-blue-400/10 border-blue-400/20",
  paid: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  overdue: "text-rose-400 bg-rose-400/10 border-rose-400/20",
  approved: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
};

export const statusLabel = (s) =>
  STATUSES.find((x) => x.value === s)?.label ||
  (s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "—");

export default function StatusBadge({ status, className = "" }) {
  const style = STYLES[status] || "text-slate-400 bg-slate-400/10 border-slate-400/20";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${style} ${className}`}
    >
      {statusLabel(status)}
    </span>
  );
}
